var _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgAssetManagement({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.3,
    cx: 32.5,
    cy: 90,
    rx: 27,
    ry: 26.5,
    transform: "rotate(-90 32.5 90)",
    fill: "#FCE400"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 90,
    cy: 90,
    rx: 27,
    ry: 27,
    transform: "rotate(-90 90 90)",
    fill: "#FCE400"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.3,
    cx: 147.5,
    cy: 90,
    rx: 27,
    ry: 26.5,
    transform: "rotate(-90 147.5 90)",
    fill: "#FCE400"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 32.5,
    cy: 32.5,
    rx: 26.5,
    ry: 26.5,
    transform: "rotate(-90 32.5 32.5)",
    fill: "#FCE400"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.3,
    cx: 90,
    cy: 32.5,
    rx: 26.5,
    ry: 27,
    transform: "rotate(-90 90 32.5)",
    fill: "#FCE400"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 147.5,
    cy: 32.5,
    rx: 26.5,
    ry: 26.5,
    transform: "rotate(-90 147.5 32.5)",
    fill: "#FCE400"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 32.5,
    cy: 147.5,
    rx: 26.5,
    ry: 26.5,
    transform: "rotate(-90 32.5 147.5)",
    fill: "#FCE400"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.3,
    cx: 90,
    cy: 147.5,
    rx: 26.5,
    ry: 27,
    transform: "rotate(-90 90 147.5)",
    fill: "#FCE400"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 147.5,
    cy: 147.5,
    rx: 26.5,
    ry: 26.5,
    transform: "rotate(-90 147.5 147.5)",
    fill: "#FCE400",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgAssetManagement);
export default __webpack_public_path__ + "static/media/IMG_asset_management.ead0aabf071eb3ceb19447169cbf3ac2.svg";
export { ForwardRef as ReactComponent };